import { IOptionType } from '@zz2/zz2-ui';
import { IUser } from '../../@types/model/right/user/user';

export default class UserHelper {

    public static getUserSiteHeading = (
        user : IUser,
        selectedSites : Array<IOptionType>
    ) : string => {
        
        const userSiteIds = user.userSites.filter(x => x.isActive).map(x => x.siteId);
    
        if (userSiteIds.length < 1) return 'NO SITE SELECTED';

        const selectedSiteCount = selectedSites.length;
     
        switch (selectedSiteCount) {
            case 0:
                return 'NO SITE SELECTED';
            case 1:
                return selectedSites[0].label;
            case userSiteIds.length:
                return 'ALL SITES';
            default:
                return 'MULTIPLE SITES';
        }

    };
}